import { ProjectReadDto } from '../_generated/api/structure'
import { StructureTypes } from './Structure'
import ApiStructureModel from './ApiStructureModel'

export default class Project extends ApiStructureModel<ProjectReadDto> {
    get referenceType() {
        return StructureTypes.Project
    }
}
